module.exports = {
  //__________PROD___________
  API_URL: "https://console.spsghy.co.in",
  BaseImageUrl: "https://console.spsghy.co.in",
  //__________DEV___________
  // API_URL: "http://80.65.208.55:8000",
  // BaseImageUrl: "http://80.65.208.55:8000",
  // API_URL: "http://localhost:8002",
  DECRYPT_KEY: "58g9Q5UaDXc_AiJzg9SHstfOmiHiaNzo0CeYVaznnK4=",
  LIMIT: 10,
  google: {
    API_KEY: "",
    CLIENT_ID:
      "23144678283-oek7ncjmmrgkgmi2i56sc411gp71a8sp.apps.googleusercontent.com",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
}
